import { useAtomValue } from "jotai";

import {
  toolsExperienceAtom,
  toolsExperienceOptionViewsAtom,
  projectTypeAtom,
  offeredGratificationAtom,
  forGratificationAtom,
  hardSkillsAtom,
  requiredAreaOfExpertiseAtom,
  projectDeadlineAtom,
  softSkillsAtom,
  offeredWorkingTypeAtomNewArray,
  offeredWorkingTypeActiveOptionsAtom,
  usedLanguagesAtom,
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  requiredAvailabilityAtomStartValue,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  locationsAtom,
} from "../components/TeammateFilters/atom/TeammateFiltersAtom";

interface reqBody {
  hardSkills?: string[];
  areaOfExpertise?: string[];
  toolsExperience?: any;
  softSkills?: string[];
  offeredGratification?: string[];
  forGratification?: string[];
  projectType?: string[];
  deadline?: Date;
  bizRole?: number;
  techRole?: number;
  availabilityFrom?: number;
  availabilityTo?: number;
  availabilityType?: string;
  workingTypeOffice?: boolean;
  workingTypeRemote?: boolean;
  usedLanguages?: string[];
  description?: string;
  locations?: string[];
}

const useDataFromTeammateFilters = () => {
  const toolsExperience = useAtomValue<string[]>(toolsExperienceAtom);
  const toolsExperienceOptionViews = useAtomValue(
    toolsExperienceOptionViewsAtom,
  );
  const projectType = useAtomValue<string[]>(projectTypeAtom);
  const offeredGratification = useAtomValue<string[]>(offeredGratificationAtom);
  const hardSkills = useAtomValue<string[]>(
    hardSkillsAtom,
  );
  const requiredAreaOfExpertise = useAtomValue<string[]>(
    requiredAreaOfExpertiseAtom,
  );
  const forGratification = useAtomValue<string[]>(forGratificationAtom);
  const projectDeadline = useAtomValue(projectDeadlineAtom);
  const softSkills = useAtomValue<string[]>(softSkillsAtom);
  const offeredWorkingTypeActiveOptions = useAtomValue<boolean[]>(
    offeredWorkingTypeActiveOptionsAtom,
  );
  const usedLanguages = useAtomValue<string[]>(usedLanguagesAtom);
  const bizOrTechRoleLeftValue = useAtomValue(bizOrTechRoleAtomLeftValue);
  const bizOrTechRoleRightValue = useAtomValue(bizOrTechRoleAtomRightValue);
  const requiredAvailabilityStartValue = useAtomValue(
    requiredAvailabilityAtomStartValue,
  );
  const requiredAvailabilityEndValue = useAtomValue(
    requiredAvailabilityAtomEndValue,
  );
  const requiredAvailabilityOption = useAtomValue(
    requiredAvailabilityAtomOption,
  );
  const locations = useAtomValue(locationsAtom);

  let body: reqBody = {};
  body.hardSkills = hardSkills;
  body.toolsExperience = [];
  body.projectType = projectType;
  body.offeredGratification = offeredGratification;
  body.forGratification = forGratification;
  body.areaOfExpertise = requiredAreaOfExpertise;
  body.deadline = projectDeadline;
  body.softSkills = softSkills;
  body.workingTypeRemote = offeredWorkingTypeActiveOptions[0];
  body.workingTypeOffice = offeredWorkingTypeActiveOptions[1];
  body.usedLanguages = usedLanguages;
  body.bizRole =
    bizOrTechRoleLeftValue == "" ? 0 : parseInt(bizOrTechRoleLeftValue);
  body.techRole =
    bizOrTechRoleRightValue == "" ? 0 : parseInt(bizOrTechRoleRightValue);
  body.availability = requiredAvailabilityAtomStartValue;
  delete body.availabilityFrom;
  delete body.availabilityTo;
  delete body.availabilityType;
  body.locations = locations;

  const keys = Object.keys(body);
  for (const key of keys) {
    if (!body[key as keyof reqBody]) {
      delete body[key as keyof reqBody];
    }
  } // is array empty we can do sth like that

  for (const tool of toolsExperience) {
    body.toolsExperience.push({
      tool: tool,
      mep: toolsExperienceOptionViews[tool],
    });
  }

  return body;
};

export { useDataFromTeammateFilters };
